<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :fieldReadonly="board.readonly" :is-print="isPrint" />

    <!-- 부가정보 : 실시-->
    <write-grid-container title="실시" v-model="form.subInfo" :options="gridContainerOptions" class="mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-textarea" v-if="dataType === 'textarea'">{{ form.subInfo[value] }}</div>
          <time-selector-rang v-else-if="dataType === 'timerang'" :isPrint="isPrint" v-model="form.subInfo[value]" />
          <div class="print-input" v-else>{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <ml-textarea v-if="dataType === 'textarea'" :readonly="board.readonly" rows="5" class="mb-0" v-model="form.subInfo[value]" />
          <time-selector-rang v-else-if="dataType === 'timerang'" :readonly="board.readonly" v-model="form.subInfo[value]" />
          <date-selector v-else-if="dataType === 'date'" :readonly="board.readonly" class="w-full" v-model="form.subInfo[value]" />
          <ml-input v-else class="w-full" :readonly="board.readonly" v-model="form.subInfo[value]" />
        </div>
      </template>
    </write-grid-container>

    <!-- 중점점검 -->
    <div>
      <h5 class="flex items-center mb-4"><i class="dot"></i>중점점검</h5>
      <ml-textarea rows="5" v-model="form.중점점검" :readonly="board.readonly" />
    </div>

    <!-- 점검결과 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      :tableData="[
        { id: 'input1', title: '구분', type: 'text' },
        { id: 'input2', title: '공정', type: 'text' },
        { id: 'input3', title: '주요사항', type: 'textarea' },
      ]"
      :mobile="['input1', 'input2']"
      v-model="form.점검결과"
      class="mb-7"
    >
      <template #customTitle>
        <div class="w-full sm:w-auto grid sm:flex items-center gap-3 mb-4">
          <div class="flex items-center gap-2">
            <h5><i class="dot"></i>점검결과</h5>
            <p>[지적사항 : {{ 지적사항개수 }}건]</p>
          </div>
          <div class="flex items-center gap-2">
            <p class="font-medium">조치기한</p>
            <date-selector :readonly="board.readonly" v-model="form.조치기한" />
          </div>
        </div>
      </template>
    </table-custom>

    <!-- 합동안전점검 결과 주요 지적사항 -->
    <ImageTable :readonly="board.readonly" :isPrint="isPrint" v-model="form.합동안전점검" class="mb-7" />

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";

import CustomOptionSelector from "@/components/selector/CustomOptionSelector";
import TimeSelectorRang from "@/components/selector/TimeSelectorRang";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom";
import ImageTable from "@/views/boards/single-page/788/ImageTable.vue";

import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    WriteGridContainer,
    CustomOptionSelector,
    TimeSelectorRang,
    DateSelector,
    TableCustom,
    ImageTable,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  computed: {
    지적사항개수() {
      // this.form.점검결과.length 값이 1일 경우, 항목들이 모두 비어있다면 0으로 처리
      if (this.form.점검결과.length === 1) {
        const { input1, input2, input3 } = this.form.점검결과[0];
        if (!input1 && !input2 && !input3) {
          return 0;
        }
        return 1;
      }

      return this.form.점검결과.length;
    }
  },
  data() {
    return {
      gridContainerOptions: {
        classes: ["writeGridLineItem", "", "", "writeGridLineItem", "writeGridLineItem"],
        dataTypes: ["textarea", "date", "timerang", "string", "string"],
        labels: ["함동점검 결과", "실시일", "실시시간", "참석팀", "참석"],
        values: ["함동점검결과", "실시일", "실시시간", "참석팀", "참석"],
      },

      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},

        중점점검: "",

        조치기한: "",
        점검결과: [],

        합동안전점검: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
